const ShopConfirm = () => import('@pages/reg/ShopConfirm')

export const reg = [
  {
    path: '/reg/pay/store',
    name: 'ShopConfirm',
    component: ShopConfirm,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/reg.route.js